import React,{useEffect} from "react";
import Spinner from "../Spinner/Spinner";
import {connect} from "react-redux";
import * as actions from "../../store/actions/index";
import {withRouter} from "react-router-dom"
import FlexContainer from "../UI/FlexContainer/FlexContainer"
const SpecfifcWorkout = props=>{

   useEffect(()=>{
        let {workoutId,workoutTitle} = props.match.params;
        props.onFetchSpecificWorkout(workoutTitle,workoutId)
 
   },[])
    const plan = props.specificWorkout;
    console.log(plan)
    if(props.workoutsLoading){
        return <Spinner/>;
    }
    
    return( 
        <>
        {/* className="container" */}
        <div className="container" >
          
           {props.specificWorkout?( 
            
           < >
               <div className="p-2 pt-3">
                    <h5>{plan.title}</h5>
               </div>
                <FlexContainer>

                        {
                            plan.workouts.map(workout=>(
                              
                                <div style={{minHeight:"230px"}} > 
                                        <iframe height="100%"
                                                    width="100%" 
                                                    src={workout.url} 
                                                    title="YouTube video player" 
                                                    frameBorder="0" 
                                                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                                    allowFullScreen="allowfullscreen"
                                                    mozallowfullscreen="mozallowfullscreen" 
                                                    msallowfullscreen="msallowfullscreen" 
                                                    oallowfullscreen="oallowfullscreen" 
                                                    webkitallowfullscreen="webkitallowfullscreen"
                                    ></iframe>
                                    <div style={{height:"40px",overflow:"clip"}}>
                                        <p><h6 >{workout.title}</h6></p>
                                    </div>
                                    
                                </div>
                                
                            ))
                        }

                </FlexContainer>
                
            </>
            ):null
            
            }

        </div> 

        </>
    )
}

const mapStateToProps = state=>{
    return{
        workoutsLoading:state.workouts.workoutsLoading,
        specificWorkout:state.workouts.specificWorkout
    }
}

const mapDispatchToProps = dispatch=>{
    return{
        onFetchSpecificWorkout:(workoutTitle,id)=>dispatch(actions.fetchSpecificWorkout(workoutTitle,id))
    }
}
export default withRouter(connect(mapStateToProps,mapDispatchToProps)(SpecfifcWorkout));



{/* <div style={{display:"flex",flexWrap:"wrap",}}>
                {
                    plan.workouts.map(workout=>(
                    <div style={{margin:"0.4em",border:"1px solid #dadada",borderRadius: "3px",width:"150px",height:"198px",textAlign:"center"}}>
                            <div > 
                                <iframe height="100%"
                                            width="100%" 
                                            src={workout.url} 
                                            title="YouTube video player" 
                                            frameBorder="0" 
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
                                            allowFullScreen="allowfullscreen"
                                            mozallowfullscreen="mozallowfullscreen" 
                                            msallowfullscreen="msallowfullscreen" 
                                            oallowfullscreen="oallowfullscreen" 
                                            webkitallowfullscreen="webkitallowfullscreen"
                            ></iframe>
                            <h6 >Youtube Video Title</h6>
                        </div>
                    </div>
                    ))
                }
                    
                </div>  */}